import { Drawer } from '@material-ui/core';
import { useAddAddress } from 'app/core/api/user/api-user';
import Button from 'app/shared/components/button/Button';
import FetchifyAddressForm, {
  DetailedAddress,
} from 'app/shared/components/fetchify-address/FetchifyAddressForm';
import { useObservableSend } from 'app/tools/hooks/misc-hooks';
import { tap } from 'rxjs';

type Props = {
  showAddCard: boolean;
  setShowAddCard: (isVisible: boolean) => unknown;
};

export default function QuoteNewAddress({
  showAddCard,
  setShowAddCard,
}: Props): JSX.Element {
  const { request$: addAddress$, sending } = useAddAddress();

  const [sendFormCommand, formCommand$] =
    useObservableSend<'submit'>();

  const submit = (data: DetailedAddress) =>
    addAddress$({
      userDisplayLocationName: data.userDisplayLocationName,
      addrLine1: data.addrLine1,
      addrLine2: data.addrLine2,
      city: data.city,
      postcode: data.postcode,
      country: data.country.code,
    }).pipe(tap(() => setShowAddCard(false)));

  return (
    <>
      <Drawer
        anchor="bottom"
        open={showAddCard}
        onClose={() => setShowAddCard(false)}
      >
        <FetchifyAddressForm
          searchPlaceholder="Start with post/zip code or street"
          onSubmit={submit}
          editable
          isAddressType
          command$={formCommand$}
        />
        <Button
          onClick={() => sendFormCommand('submit')}
          pending={sending}
        >
          Save
        </Button>
      </Drawer>
    </>
  );
}
